<template>
  <section
    :class="['app-layout']"
  >
    <main>
      <section class="main">
        <ViewMain />
      </section>
    </main>
  </section>
</template>
<script lang="ts" setup>
import { computed, ref } from 'vue'
import ViewMain from './components/main.vue'
import { RouteLocationMatched, useRoute } from 'vue-router'
import { MenuMode } from '@/typings/data'
import { get } from 'lodash-es'

// hooks
const route = useRoute()

const showHeader = computed(() => {
  return false
})

const showSide = false

const matched = computed<RouteLocationMatched[]>(() => route.matched || [])

const metaMenu = computed<MenuMode>(() => (route.meta?.data || {}) as MenuMode)


// fns
function getMachedPicture() {
  let picture: any[] = []
  matched.value.find((item: RouteLocationMatched) => {
    const mData = item.meta?.data as MenuMode
    if (mData?.picture) {
      picture = JSON.parse(mData.picture)
      return true
    }
  })
  return picture
}
</script>
<style lang="scss" scoped>
.app-layout {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background-size: 100% ;
  background-repeat: no-repeat;
  background-position: top;
  background-color: #F6F7F9;
  &.showHeader {
    header {
      height: $page-header-height;
      padding: 0;
    }
  }
  header {
    position: relative;
    width: 100%;
    z-index: 33;
  }

  main {
    // margin: 20px 24px 24px 24px;
    position: relative;
    display: flex;
    flex: 1;
    .aside {
      width: $page-aside-width;
      margin-right: 20px;
      background: #FFFFFF;
      border-radius: 4px 4px 4px 4px;
      overflow: hidden;
      padding: 6px 10px;
    }
    .main {
      flex: 1;
      height: 100%;
    }
  }
  .fixed-container {
    position: fixed;
  }
  .bg-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
